/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { filterOutWhiteSpace } from '../utils/general-utils';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const v1 = {
  supports: {
    html: false,
    multiple: false
  },
  save() {
    const blockProps = useBlockProps.save({
      className: `block__list-with-filters mt-25 mb-60`
    });

    const innerBlocksClasses = filterOutWhiteSpace( [
      'inner-blocks-wrapper'
    ] );

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: innerBlocksClasses
    });

    return (
      <div { ...blockProps }>
        <div className='list-with-filters--inner'>
          <div { ...innerBlocksProps }>
            { children }
          </div>
        </div>
      </div>
    );
  }
};

export default [ v1 ];
